import { render, staticRenderFns } from "./WaitingRoomDelete.vue?vue&type=template&id=0da207c8&"
import script from "./WaitingRoomDelete.vue?vue&type=script&lang=js&"
export * from "./WaitingRoomDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports